import { getFilters, KEY_TEXT_SEARCH } from '../../../util/filters';

const startingFilters = getFilters();

export const initialState = {
	searchText: startingFilters[KEY_TEXT_SEARCH] || undefined
};

export default initialState;
